export default __webpack_public_path__ + "static/media/5.3e9333ab.png";